import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { AppRoute } from '../routes.types';

const AllyPage = lazyWithRetry(() => import('../../venues/pages/AllyPage/AllyPage'));

export const ALLY_ROUTES: AppRoute[] = [
    { path: '', element: <AllyPage /> },
];
